<template>
  <div class="product-review-answer">
    <product-review-head
      class="product-user-review__head"
      :date="date"
      answer
    />

    <message-cloud
      answer
      :text="text"
    />
  </div>
</template>

<script>
import ProductReviewHead from './product-review-head.vue';
import MessageCloud from './message-cloud.vue';

export default {
  name: "product-review-answer",

  components: {
    ProductReviewHead,
    MessageCloud,
  },

  props: {
    text: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss">
  .product-review-answer {
    border-radius: 4px 16px 16px 16px;
    padding: 16px;
    background: $white;

    @include breakpoint("desktop") {
      padding: 24px;
    }
  }
</style>